import { useEffect, useState } from "react";
import { useEnglishText } from "../../../text/useEnglishText.js";

import DocumentsList from "../../layout/DocumentsList";
import RoleModal from "./RoleModal";

import { getCustomerUserRoles } from "../../../services/customerService";
import IconAction from "../../common/IconAction";
import { Pencil, Plus } from "lucide-react";

const RolesPermissionsTab = () => {
  const { t } = useEnglishText();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const [page, setPage] = useState("1");
  const [pageSize] = useState("10");

  const load = async () => {
    setLoading(true);
    setErr("");

    try {
      const data = await getCustomerUserRoles("ROLE");

      setRows(Array.isArray(data) ? data : (data?.data ?? []));
    } catch (e) {
      setErr(
        e?.response?.data?.message ||
          e.message ||
          t("messages.errorLoadingRoles")
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="profile-section__header">
        <h3 className="profile-section__title">
          {t("settings.roles.title")}
        </h3>

        <div className="profile-section__actions">
          <IconAction
            icon={Pencil}
            label={t("common.edit", "Edit")}
            disabled={!selectedItem}
            onClick={() => {
              setEditing(selectedItem);
              setOpenModal(true);
            }}
          />

          <IconAction
            icon={Plus}
            label={t("settings.roles.addBtn", "Add role")}
            onClick={() => {
              setEditing(null);
              setOpenModal(true);
            }}
          />
        </div>
      </div>

      <DocumentsList
          data={rows}
          loading={loading}
          error={err}
          emptyTitle={t("settings.roles.empty", "No roles found")}
          onSelect={setSelectedItem}
          page={parseInt(page)}
          pageSize={parseInt(pageSize)}
          paginateLocally
          onPageChange={(p) => setPage(String(p))}
      />

      <RoleModal
        open={openModal}
        initialValue={editing}
        onClose={() => {
          setOpenModal(false);
          setEditing(null);
        }}
        onSaved={() => {
          setOpenModal(false);
          setEditing(null);

          load();
        }}
      />
    </>
  );
};

export default RolesPermissionsTab;
